var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{ref:"input",staticClass:"input",attrs:{"type":_vm.type,"placeholder":_vm.label,"maxlength":_vm.maxlength,"min":_vm.min,"max":_vm.max,"readonly":_vm.readonly},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }